/**
 * AlertBadge - Shows unread alert count for sidebar
 * Planner - Alert System
 */

import { useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Bell } from 'lucide-react'
import { useAlerts } from '@/hooks/useAlerts'

export default function AlertBadge({ className, showIcon = true, asButton = false }) {
  const navigate = useNavigate()
  const { unreadCount, criticalCount, loading } = useAlerts()

  if (loading || unreadCount === 0) return null

  const hasCritical = criticalCount > 0

  const content = (
    <>
      {showIcon && <Bell className="w-4 h-4" />}
      <span className={cn(
        'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5',
        'text-xs font-semibold rounded-full',
        hasCritical ? 'bg-red-500 text-white' : 'bg-amber-500 text-white'
      )}>
        {unreadCount > 99 ? '99+' : unreadCount}
      </span>
    </>
  )

  if (asButton) {
    return (
      <button
        onClick={() => navigate('/alerts')}
        className={cn(
          'inline-flex items-center gap-2 p-2 rounded-md',
          'hover:bg-accent transition-colors',
          className
        )}
      >
        {content}
      </button>
    )
  }

  return <div className={cn('inline-flex items-center gap-2', className)}>{content}</div>
}

export function AlertBadgeCompact({ className }) {
  const { unreadCount, criticalCount, loading } = useAlerts()
  if (loading || unreadCount === 0) return null

  return (
    <span className={cn(
      'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5',
      'text-xs font-semibold rounded-full',
      criticalCount > 0 ? 'bg-red-500 text-white' : 'bg-amber-500 text-white',
      className
    )}>
      {unreadCount > 99 ? '99+' : unreadCount}
    </span>
  )
}
